export const GRID_CELL_SIZE = 0.1;

export const calculateGridKey = (latitude: number, longitude: number): string => {
  const latitudeKey = Math.floor(latitude / GRID_CELL_SIZE);
  const longitudeKey = Math.floor(longitude / GRID_CELL_SIZE);
  return `${latitudeKey}_${longitudeKey}`;
};
